import Cookie from 'js-cookie'
import { loginStore } from '@/store/loginStore'
const { login, logout } = loginStore.getState()

export default {
  login: (cookieOptions) => {
    Cookie.set('login', 'true', cookieOptions)
    window.localStorage.setItem('login', true)
    login()
    // subWarning()
  },
  logout: () => {
    Cookie.remove('login')
    window.localStorage.removeItem('login')
    logout()
  }
}
